<template>
  <div>
    <b-row>
      <b-col
        cols="12"
        md="8"
      >
        <b-card>
          <b-row>
            <b-col
              cols="12"
            >
              <licence-token />
            </b-col>
            <b-col
              cols="12"
              md="6"
            >
              <licence-sdate />
            </b-col>
            <b-col
              cols="12"
              md="6"
            >
              <licence-edate />
            </b-col>
            <b-col
              cols="12"
              md="12"
            >
              <licence-project />
            </b-col>
            <b-col
              cols="12"
              md="12"
            >
              <licence-project-package />
            </b-col>
            <b-col
              cols="12"
              md="6"
            >
              <licence-auto-suspend />
            </b-col>
            <b-col
              cols="12"
              md="6"
            >
              <licence-status />
            </b-col>
            <b-col
              cols="12"
              md="12"
            >
              <licenses-notes />
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col
        cols="12"
        md="4"
      >
        <licence-customer />
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { BCard, BRow, BCol } from 'bootstrap-vue'
import LicensesNotes from '@/views/Admin/Licenses/Elements/Notes.vue'
import LicenceToken from '@/views/Admin/Licenses/Elements/Token.vue'
import LicenceSdate from '@/views/Admin/Licenses/Elements/sDateCard.vue'
import LicenceEdate from '@/views/Admin/Licenses/Elements/eDateCard.vue'
import LicenceProject from '@/views/Admin/Licenses/Elements/Project.vue'
import LicenceProjectPackage from '@/views/Admin/Licenses/Elements/ProjectPackage.vue'
import LicenceAutoSuspend from '@/views/Admin/Licenses/Elements/AutoSuspend.vue'
import LicenceStatus from '@/views/Admin/Licenses/Elements/Status.vue'
import LicenceCustomer from '@/views/Admin/Licenses/Elements/Customer.vue'

export default {
  name: 'LicencesItemForm',
  components: {
    LicenceCustomer,
    LicenceStatus,
    LicenceAutoSuspend,
    LicenceProjectPackage,
    LicenceProject,
    LicenceEdate,
    LicenceSdate,
    LicenceToken,
    LicensesNotes,
    BCard,
    BRow,
    BCol,
  },
}
</script>
